var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,{tag:"component",attrs:{"data":_vm.data,"isPreview":_vm.isPreview,"isShow":_vm.isShow,"isRefresh":_vm.isRefresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }